import { Lang, ReportReason } from 'cat-shared/utils'

export default {
  [Lang.EN]: {
    modals: {
      noAccess: {
        header: 'Action required',
        description: {
          actionNotAllowedReasonOne:
            "In order to make it possible for you to answer any of the questions or create new - you need to have an account, which we can then reuse to store and retrieve data such as history of your answers etc. If you don't have an account yet - click REGISTER, otherwise just LOG IN.",
          actionNotAllowedReasonTwo:
            'Your account is not fully activated. You still need to confirm your e-mail. Just go to your inbox, find email with the title "CAT App - account verification", open it and click VERIFY. After that, your account will be ready to use :)',
          actionNotAllowedReasonThree:
            'To activate all the features for good, please go to settings and make one time payment.',
        },
      },
      deleteAccount: {
        header: 'Deactivation',
        content: 'Are you sure you want to proceed with this action ?',
      },
      deleteQuestion: {
        header: 'Warning',
        description:
          'You are about to delete your question. Are you sure you want to do this ?',
      },
      reportQuestion: {
        header: 'Report question',
        description: 'What is the reason you are reporting this question ?',
        reasons: {
          [ReportReason.BadContent]: 'It has got an inappropriate content',
          [ReportReason.Duplicate]: 'It is a duplicate',
          [ReportReason.WrongLanguage]: 'It is written in a wrong language',
          [ReportReason.WrongCategory]: 'It has got a wrong category',
          [ReportReason.Other]: 'Other',
        },
      },
      submitQuestion: {
        header: 'Still answering ...',
        description:
          "You haven't answered the question yet. Please press ANSWER to submit it or RESET to discard your selection.",
      },
    },
  },
}
